<template>
  <div>
    <div class="mb-2 d-flex justify-content-between align-items-center">
      <h3>Gifts</h3>

      <div class="d-flex justify-content-between gap-20">
        <b-button @click="openPopup" variant="warning" class="add_button text-white">
          Add Gift <i class="las la-plus ml-3"></i>
        </b-button>
      </div>
    </div>

    <main-table
      :fields="columns"
      class="mb-0 table-borderless"
      :list_url="'gifts'"
      :custom-filter="{
        'user_id' : $route.params.id
      }"
    >
      <template v-slot:expire_date="data">
        {{data.data.expire_date ? getRemainingDays(data.data.expire_date) + ' Days' : '--'}}
      </template>
    </main-table>

    <main-modal id="AddGiftModal">
      <template v-slot:header>
        <h4 class="font-weight-bold">
          <span class="text-warning" >Add: </span> Gift
        </h4>
      </template>
      <template v-slot:body>
        <ManagementGiftForm @addGift="addNewGift" :requestLoading="requestLoading"/>
      </template>
    </main-modal>
    
    <main-modal id="ViewGiftModal">
      <template v-slot:header>
        <h4 class="font-weight-bold">
          <span class="text-info" >View: </span> Gift
        </h4>
      </template>
      <template v-slot:body>
        <ManagementGiftView :details="details" />
      </template>
    </main-modal>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import { managementGiftsItems } from '../services/data'
import ManagementGiftForm from '../components/ManagementGiftForm.vue'
import managementServices from '../services/management.services'
import ManagementGiftView from '../components/ManagementGiftView.vue';

export default {
  data () {
    return {
      items: managementGiftsItems,
      columns: [
        { label: '#', key: '#', class: 'text-center', type: 'sort' },
        { label: 'Date', key: 'created_at', class: 'text-left text-bold', type: 'date' },
        { label: 'Type', key: 'type', class: 'text-left' },
        { label: 'Name', key: 'name', class: 'text-left' },
        { label: 'Quantity', key: 'quantity', class: 'text-left' },
        { label: 'Validity', key: 'expire_date', class: 'text-left', type: 'custom' },
        {
          label: 'Actions',
          key: 'actions',
          class: 'text-left',
          type: 'actions',
          actions: [
            {
              icon: 'las la-eye',
              color: 'success-light',
              text: 'View',
              actionName: 'showGift',
              actionParams: 'fullObj'
            },
            {
              icon: 'las la-folder-plus',
              color: 'warning',
              text: 'Edit',
              actionName: 'showGiftToEdit',
              actionParams: 'fullObj'
            }
          ]
        }
      ],
      requestLoading: false,
      reloadTable: false,
      details: null
    }
  },
  components: {
    ManagementGiftForm,
    ManagementGiftView
  },
  methods: {
    getRemainingDays(dateString) {
      const today = new Date();
      const targetDate = new Date(dateString);

      today.setHours(0, 0, 0, 0);
      targetDate.setHours(0, 0, 0, 0);

      const diffTime = targetDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays;
    },
    openPopup () {
      this.$bvModal.show('AddGiftModal')
    },
    addNewGift (payload) {
      this.requestLoading = true
      this.reloadTable = false
      managementServices.addNewGift(payload).then((res) => {
        this.reloadTable = true
        core.showSnackbar('success', res.data.message)
        this.$bvModal.hide('AddGiftModal')
        this.requestLoading = false
      }).finally(() => {
        this.requestLoading = false
      })
    },
    showGift(data) {
      this.details = data
      this.$bvModal.show('ViewGiftModal')
    }
  },
  created () {
    this.$root.$on('showGift', this.showGift)
  },
  beforeDestroy () {
    this.$root.$off('showGift')
  },
  mounted () {
    core.index()
  }
}
</script>
